import { useEventListener } from '@vueuse/core'
import { ref } from 'vue'
import { useApi } from '@/functions/api'

export function useBranchesList () {
  const api = useApi()
  const branches = ref<Branch[]>([])
  const loading = ref(false)

  const getData = async () => {
    try {
      loading.value = true
      const response = await api.GET<ApiCollection<Branch>>('cashier/branch')
      branches.value = response.data
    } finally {
      loading.value = false
    }
  }

  return {
    getData,
    loading,
    branches,
  }
}

export function useSharedBranchId () {
  const VALUE_KEY = 'admin_current_branch_id'
  const TIMESTAMP_KEY = 'admin_current_branch_id_timestamp'
  const EXPIRED_AFTER = 1000 * 60 * 60 * 3 // 3 hours
  const isExpired = () => {
    const timestamp = localStorage.getItem(TIMESTAMP_KEY)
    if (!timestamp) return true
    const ts = Number(timestamp)
    return Date.now() - ts > EXPIRED_AFTER
  }
  const getBranchId = () => {
    if (isExpired()) {
      resetBranchId()
    }
    const id = localStorage.getItem(VALUE_KEY)
    return id ? Number(id) : null
  }
  const setBranchId = (id: number) => {
    localStorage.setItem(VALUE_KEY, id.toString())
    localStorage.setItem(TIMESTAMP_KEY, Date.now().toString())
  }
  const resetBranchId = () => {
    localStorage.removeItem(VALUE_KEY)
    localStorage.removeItem(TIMESTAMP_KEY)
  }

  const onBranchIdUpdated = (callback: () => void) => {
    useEventListener('storage', (event) => {
      if (event.key === VALUE_KEY && event.newValue !== event.oldValue) {
        callback()
      }
    })
  }

  // on branch_id change handled in the App.vue

  return {
    setBranchId,
    getBranchId,
    resetBranchId,
    onBranchIdUpdated,
  }
}
